const createCostPolicy = (policy) => policy;
export const SPEECH_PROVIDER_MODEL_PROFILES = {
    elevenlabs: {
        narration: 'elevenlabs:eleven_v4',
        realtime: 'elevenlabs:eleven_v4_turbo',
        cheap: 'elevenlabs:eleven_flash_v2_5'
    }
};
export const SPEECH_PROVIDER_MODEL_PROFILE_COST_POLICIES = {
    elevenlabs: {
        narration: createCostPolicy({
            maxCharacterCostMultiplier: 1,
            notes: 'Narration defaults may use any base-rate model (1 credit per character); higher multipliers require explicit approval.'
        }),
        realtime: createCostPolicy({
            maxCharacterCostMultiplier: 0.5,
            notes: 'Real-time defaults must stay on a half-rate low-latency model.'
        }),
        cheap: createCostPolicy({
            maxCharacterCostMultiplier: 0.5,
            notes: 'Cheap defaults must stay on a half-rate model.'
        })
    }
};
export const SPEECH_GLOBAL_MODEL_PROFILES = SPEECH_PROVIDER_MODEL_PROFILES.elevenlabs;
//# sourceMappingURL=speechModelProfiles.js.map